import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { NavLink, useParams } from "react-router-dom";
import { doulaActions } from "../../../store/doulaSlice";
import { elencoletture } from "../../../config/elencoletture";
import "./dettaglioLettura.css";
import { MdArrowForwardIos } from "react-icons/md";
import { MdArrowBackIos } from "react-icons/md";
import { Helmet } from "react-helmet";
export const DettaglioLettura = () => {
    const { lettura } = useSelector((state) => state.doula);
    const params = useParams();
    const dispatch = useDispatch();
    const index = params.dettaglio;

    useEffect(() => {
        const currentService = elencoletture.filter((el) => el.index == index);

        dispatch(doulaActions.replaceLettura(currentService[0]));
    }, [params]);

    return (
        <>
            <title>
                <Helmet> Dettaglio Lettura </Helmet>
            </title>
            <section className="pb-5 bgCream" id="dettaglioLettura">
                <h2 className="fs-1 text-center py-5 textBlue">{lettura.title}</h2>
                <div className="container relative flex-grow-1">
                    {window.screen.width > 500 && (
                        <NavLink
                            className="arrow-right"
                            to={
                                parseInt(index) == elencoletture.length - 1
                                    ? "/letture/0"
                                    : "/letture/" + (parseInt(index) + 1)
                            }
                        >
                            <MdArrowForwardIos />
                        </NavLink>
                    )}
                    {window.screen.width > 500 && (
                        <NavLink
                            className="arrow-left"
                            to={
                                parseInt(index) == 0
                                    ? "/letture/" + parseInt(elencoletture.length - 1)
                                    : "/letture/" + (parseInt(index) - 1)
                            }
                        >
                            <MdArrowBackIos />
                        </NavLink>
                    )}

                    <div className="col-12">
                        <div className="pb-4 ps-md-3 pt-md-3 float-md-end widthDynamic margin-center pt-lg-0">
                            <img className="immagine-lettura" src={lettura.img} alt="" />
                        </div>

                        <div
                            className="textBlue"
                            id="testo-lettura"
                            dangerouslySetInnerHTML={{ __html: lettura.text }}
                        />
                    </div>

                    <h5 className="textBlue mt-5">
                        {lettura.download != ""
                            ? "Vuoi leggere il PDF? scaricalo cliccando "
                            : "Compila il sondaggio cliccando "}
                        <a
                            target="_blank"
                            className="textBlue underline-none "
                            href={lettura.download != "" ? lettura.download : lettura.link}
                        >
                            qui
                        </a>
                    </h5>
                </div>
            </section>
        </>
    );
};
